import React from "react";
import styled from "styled-components";

const CardWrapper = styled.div`
  width: 366px;
  height: 356px;
  border: 1px solid #e5e5e5;
  border-radius: 4px;
  cursor: pointer;
  padding: 24px 16px;
  &:hover {
    border-color: #2196f3;
  }
`;

const CardTextWrapperMain = styled.div`
  width: 200px;
  height: auto;
  margin: 32px 0 32px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
`;

const CardTextWrapper = styled.div`
  width: 100px;
  height: auto;
  text-align: start;
`;

type TextProps = {
  fontweight: string;
  fontsize: string;
  margin?: string;
  color: string;
};

export const StyledText = styled.p<TextProps>`
  font-size: ${(props) => props.fontsize};
  font-weight: ${(props) => props.fontweight};
  color: ${(props) => props.color};
  margin: ${(props) => props.margin};
`;

type CardProps = {
  id: string;
  title: string;
  client: string;
  due: string;
  count: number;
  amount: number;
  method: string[];
  material: string[];
  status: string;
};

const StyledLine = styled.div`
  width: 334px;
  height: 1px;
  background-color: #e5e5e5;
`;

const StyledStatusWrapper = styled.div`
  width: 333px;
  height: 26px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const StyledStatusIndicator = styled.div`
  border-radius: 12px;
  border: 1px solid #ffa000;
  font-size: 12px;
  color: #ffa000;
  padding: 2px 8px;
`;

const StyledCardBtnWrapper = styled.div`
  width: 192px;
  height: 33px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

type BtnProps = {
  border?: string;
  color: string;
  background_color: string;
};

const StyledBtn = styled.button<BtnProps>`
  padding: 5px 11px;
  background-color: ${(props) => props.background_color};
  border: ${(props) => (props.border ? props.border : "none")};
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  color: ${(props) => props.color};
  cursor: pointer;
`;

export default function Card(props: CardProps) {
  return (
    <CardWrapper id={props.id}>
      <StyledStatusWrapper>
        <StyledText color={"#323D45"} fontsize={"16px"} fontweight={"700"}>
          {props.title}
        </StyledText>
        {props.status === "상담중" && (
          <StyledStatusIndicator>{props.status}</StyledStatusIndicator>
        )}
      </StyledStatusWrapper>
      {}
      <StyledText
        margin={"4px 0 20px 0"}
        color={"#323D45"}
        fontsize={"14px"}
        fontweight={"500"}
      >
        {props.client}
      </StyledText>
      {}
      <StyledText
        margin={"0 0 16px 0"}
        color={"#939FA5"}
        fontsize={"14px"}
        fontweight={"500"}
      >
        {props.due}까지 납기
      </StyledText>
      {}
      <StyledLine />
      {}
      <CardTextWrapperMain>
        <CardTextWrapper>
          <StyledText color={"#323D45"} fontsize={"14px"} fontweight={"400"}>
            도면개수
          </StyledText>
          {}
          <StyledText
            margin={"8px 0 "}
            color={"#323D45"}
            fontsize={"14px"}
            fontweight={"400"}
          >
            총 수량
          </StyledText>
          {}
          <StyledText
            margin={"0 0 8px 0"}
            color={"#323D45"}
            fontsize={"14px"}
            fontweight={"400"}
          >
            가공방식
          </StyledText>
          {}
          <StyledText color={"#323D45"} fontsize={"14px"} fontweight={"400"}>
            재료
          </StyledText>
        </CardTextWrapper>

        <CardTextWrapper>
          <StyledText color={"#323D45"} fontsize={"14px"} fontweight={"700"}>
            {props.count}개
          </StyledText>
          {}
          <StyledText
            margin={"8px 0 "}
            color={"#323D45"}
            fontsize={"14px"}
            fontweight={"700"}
          >
            {props.amount}개
          </StyledText>
          {}
          <StyledText
            margin={"0 0 8px 0"}
            color={"#323D45"}
            fontsize={"14px"}
            fontweight={"700"}
          >
            {props.method?.map((item, i) => {
              return item;
            })}
          </StyledText>
          {}
          <StyledText color={"#323D45"} fontsize={"14px"} fontweight={"700"}>
            {props.material?.map((item, i) => {
              return item;
            })}
          </StyledText>
          {}
        </CardTextWrapper>
      </CardTextWrapperMain>

      <StyledCardBtnWrapper>
        <StyledBtn
          color={"#fff"}
          background_color={"#2196F3"}
          border={"1px solid #2196F3"}
        >
          요청 내역 보기
        </StyledBtn>
        <StyledBtn
          color={"#2196F3"}
          background_color={"#fff"}
          border={"1px solid #2196F3"}
        >
          채팅하기
        </StyledBtn>
      </StyledCardBtnWrapper>
    </CardWrapper>
  );
}
